import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnDestroy,
    OnInit,
} from '@angular/core';
import {
    FormBuilder,
    FormGroup,
} from '@angular/forms';
import {
    AssetScope,
    IAsset,
    IAssetType,
} from '@models';

import { Subject } from 'rxjs';

import {
    AssetCredentialValidator,
    getValueFor,
    resetForm,
    validatorsFor,
} from '../../utils';

@Component({
    selector: 'ui-single-value-editor',
    templateUrl: './ui-single-value-editor.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiSingleValueEditorComponent implements OnInit, OnDestroy {
    @Input()
    public set type(type: IAssetType) {
        this._type = type;
        if (this.formGroup && this.formGroup.get('value')) {
            resetForm(this.formGroup, 'value', this._type, this.isNewEntry, this._readonly);
        }
    }
    public get type() {
        return this._type;
    }

    @Input()
    public typeLabel!: string;
    @Input()
    public externalName!: string;
    @Input()
    public asset!: IAsset;
    @Input()
    public isNewEntry!: boolean;
    @Input()
    public disabled!: boolean;
    @Input()
    public credentialStoreChange$!: Subject<void>;
    @Input()
    public set readonly(readonly: boolean | undefined) {
        this._readonly = readonly;
        if (this._type === 'Credential' && this.formGroup && this.formGroup.get('value')) {
            resetForm(this.formGroup, 'value', this._type, this.isNewEntry, readonly, false, this.asset.externalName);
        }
    }
    public get readonly() {
        return this._readonly;
    }
    @Input()
    public valueHintEnabled = true;

    public formGroup!: FormGroup;

    public AssetScope = AssetScope;

    private _type!: IAssetType;
    private _readonly?: boolean;

    constructor(private _fb: FormBuilder) { }

    ngOnInit() {
        this.formGroup = this._fb.group({
            'value': [
                getValueFor(this.asset, this.readonly),
                validatorsFor(this.asset.type, !!this.isNewEntry, this.readonly),
            ],
        }, {
                validator: AssetCredentialValidator('value', () => this.type, () => this.asset, () => this.readonly),
            });

        this.credentialStoreChange$.subscribe(_ => {
            if (this._type === 'Credential' && this.formGroup && this.formGroup.get('value')) {
                resetForm(this.formGroup, 'value', this._type, this.isNewEntry, this._readonly, false);
            }
        });
    }

    ngOnDestroy() {
        this.credentialStoreChange$.complete();
    }
}
